import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

// GSAP runs every tween and scroll scene on the site. Its ticker is the site's one animation
// loop: the store subscribes to it, so the black hole, the gravity engine, ScrollTrigger and
// every tween advance in the same frame.

let registered = false
let refreshTimer = 0

export const ensureMotion = (): typeof gsap => {
    if (!registered && typeof window !== 'undefined') {
        registered = true
        gsap.registerPlugin(ScrollTrigger)
        gsap.ticker.lagSmoothing(500, 33)
        ScrollTrigger.config({ ignoreMobileResize: true })
    }

    return gsap
}

// Scroll scenes measure their start and end once. Whenever the page changes height (fonts,
// images, a page entering) they are measured again, a moment later and only once per burst.
export const queueScrollRefresh = (delay = 140): void => {
    if (typeof window === 'undefined' || !registered) return

    window.clearTimeout(refreshTimer)
    refreshTimer = window.setTimeout(() => ScrollTrigger.refresh(), delay)
}

export const prefersReducedMotion = (): boolean => (
    typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches
)

export { gsap, ScrollTrigger }
